<template>
    <div v-if="items.length > 0" 
        class="alert alert-danger" 
        role="alert"
    >
        <button aria-label="Fermer" class="close" @click="$emit('errors-closed')"></button>

        <ul>
            <li v-for="(item, idx) in items" :key="'error-' + idx">{{ item }}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default: []
            }
        }
    }
</script>

<style lang="scss" scoped>
    .alert {
        .close {
            z-index: 10;
        }

        ul {
            li {
                list-style: disc inside none;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/SocialCertificate/EditionForm/Errors.vue